import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { FontText, PrimaryButton } from '../common';
import './ChapterNavigation.css';

interface ChapterNavigationProps {
  hasNextChapter: boolean;
  hasPreviousChapter: boolean;
  currentChapter: number;
  totalChapters: number;
  bookSlug: string;
  onNextChapter?: () => void;
  onPreviousChapter?: () => void;
}

export const ChapterNavigation: React.FC<ChapterNavigationProps> = ({
  hasNextChapter,
  hasPreviousChapter,
  currentChapter,
  totalChapters,
  bookSlug,
  onNextChapter,
  onPreviousChapter,
}) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const styles: Record<string, React.CSSProperties> = {
    endMessage: {
      padding: '20px',
      backgroundColor: theme.colors.overlay,
      borderRadius: 12,
    },
    endText: {
      color: theme.colors.text,
      margin: 0,
    },
    buttonLink: {
      textDecoration: 'none',
      display: 'block',
    },
  };

  if (!hasNextChapter) {
    return (
      <div className="chapter-navigation-container">
        <div style={styles.endMessage}>
          <FontText normal style={styles.endText}>
            {currentChapter === totalChapters
              ? t('book_ended')
              : t('more_chapters_soon')}
          </FontText>
        </div>
      </div>
    );
  }

  return (
    <div className="chapter-navigation-container">
      {hasPreviousChapter ? (
        <Link
          to={`/books/${bookSlug}/chapter/${currentChapter - 1}`}
          style={styles.buttonLink}
          onClick={onPreviousChapter}
        >
          <PrimaryButton>{t('previous_chapter')}</PrimaryButton>
        </Link>
      ) : (
        <div style={{ height: 40 }} />
      )}
      <Link
        to={`/books/${bookSlug}/chapter/${currentChapter + 1}`}
        style={styles.buttonLink}
        onClick={onNextChapter}
      >
        <PrimaryButton>{t('next_chapter')}</PrimaryButton>
      </Link>
    </div>
  );
};
